import { useMemo } from 'react';
import { cx } from '@/utils';
import { useLayoutContext } from '@common/Layout/LayoutProvider/LayoutContext';

import CustomLink from '../../CustomLink';

const FooterLinks = ({ color = 'text-primary' }) => {
  const {
    layout: { pageFooterBar },
  } = useLayoutContext();
  const directories = useMemo(() => {
    if (pageFooterBar?.items) {
      return pageFooterBar.items.filter(
        (item) => item.footerType === 'IsDirectory' && item.pageDirectoryLink
      );
    }
  }, [pageFooterBar?.items]);

  return (
    <div className={'mt-5 flex flex-wrap items-center gap-[32px]'}>
      {directories?.map((directory, key) => {
        const slug = directory.pageDirectoryLink?.dynamicPageSlugs?.[0]?.slug;
        const pageLink = slug
          ? { ...directory.pageDirectoryLink, url: slug }
          : directory.pageDirectoryLink;

        return (
          <CustomLink key={key} pageLink={pageLink as any}>
            <div className={cx(color)}>{directory.pageDirectory}</div>
          </CustomLink>
        );
      })}
    </div>
  );
};

export default FooterLinks;
